import { APP_BASE_HREF } from '@angular/common';
import { provideHttpClient, withInterceptorsFromDi
       } from '@angular/common/http';
import { NgModule, Injectable, Injector, DoBootstrap, ApplicationRef
       } from '@angular/core';
import { createCustomElement } from '@angular/elements';
import { FormsModule } from '@angular/forms';
import { BrowserModule } from '@angular/platform-browser';
import { RouterModule } from '@angular/router';

import { CollageDesignerModule
       } from 'collage-designer/collage-designer.module';
import { ConfigService } from 'core/config/config.service';
import { CoreModule } from 'core/core.module';
import { ErrorModule } from 'core/error/error.module';
import { MatModule } from 'core/material/mat.module';
import { PipesModule } from 'core/pipes/pipes.module';
import { PriceModule } from 'core/price/price.module';
import { EventTrackingService } from 'core/tracking/event-tracking.service';
import { TranslationModule } from 'core/translation/translation.module';
import { version } from '../environments/version';
import { AdditionalProductsSelectionComponent
       } from './additional-products-selection/additional-products-selection.component'; // eslint-disable-line
import { ControlsModule } from './controls/controls.module';
import { DialogsModule } from './dialogs/dialogs.module';
import { FeatureSelectionComponent
       } from './feature-selection/feature-selection.component';
import { GalleryService } from './gallery/gallery.service';
import { OfflineNoticeComponent } from './offline-notice.component';
import { ProductDesignerComponent } from './product-designer.component';
import { ProductDesignerService } from './product-designer.service';
import { ProgressModule } from './progress/progress.module';
import { ProgressService } from './progress/progress.service';
import { ToolboxesModule } from './toolboxes/toolboxes.module';



@NgModule({ declarations: [
        AdditionalProductsSelectionComponent,
        FeatureSelectionComponent,
        OfflineNoticeComponent,
        ProductDesignerComponent,
    ],
    imports: [
        BrowserModule,
        CoreModule.forRoot(),
        CollageDesignerModule,
        ControlsModule,
        ErrorModule,
        FormsModule,
        MatModule,
        PipesModule,
        PriceModule,
        ProgressModule,
        RouterModule.forRoot([], {}),
        ToolboxesModule,
        DialogsModule,
        TranslationModule],
    providers: [
        EventTrackingService,
        ConfigService,
        GalleryService,
        ProductDesignerService,
        ProgressService,
        { provide: APP_BASE_HREF, useValue: '/' },
        provideHttpClient(withInterceptorsFromDi()),
    ]})
export class ProductDesignerModule implements DoBootstrap {
  private buildVersion: string = version;
  constructor(private injector: Injector) {
    // eslint-disable-next-line
    console.info("ProductDesigner-Build-Version: ", this.buildVersion);
  }

  ngDoBootstrap(appRef: ApplicationRef) {
    const webComponentSelector = 'product-designer-component';
    const angularSelector = 'product-designer';

    if (!customElements.get(webComponentSelector)) {
      const productdesigner = createCustomElement(ProductDesignerComponent,
                                                 { injector: this.injector });
      customElements.define(webComponentSelector, productdesigner);
    }

    const angularHost = document.querySelector(angularSelector);
    if (angularHost) {
       appRef.bootstrap(ProductDesignerComponent);
    }
  }
}
